module.exports = __webpack_public_path__ + "media/Video 71.ff42f734.mp4";